export default __webpack_public_path__ + "static/media/thumbnail.510bdcec.png";